import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import { object, string } from 'yup';
import cc from 'classcat';

import Button from '../Button';
import { FormikSimplifiedInput as SimplifiedInput } from '../Form';
import { themes } from '../../lib/themes';

import styles from './styles.module.scss';

const ActionForm = ({
  theme,
  title,
  buttonLabel,
  placeholder,
  autoFocus,
  type,
  clickId,
  className,
  handleSubmit,
  isSubmitting,
  errors,
  touched,
  titleClassName,
  formClassName,
  inputClassName,
  buttonClassName,
}) => (
  <div className={className}>
    {!!title && <h2 className={cc([styles.title, titleClassName])}>{title}</h2>}
    <form
      method="post"
      onSubmit={handleSubmit}
      className={cc([styles[theme], styles.form, formClassName])}
    >
      <SimplifiedInput
        className={cc([
          styles.input,
          { [styles.error]: errors.value && touched.value },
          inputClassName,
        ])}
        inputClassName={styles.inputInner}
        type={type}
        name="value"
        placeholder={isSubmitting ? 'Working...' : placeholder}
        inlineError={false}
        autoFocus={autoFocus ? true : null}
      />
      <Button
        theme={theme}
        type="submit"
        className={cc([styles.button, buttonClassName])}
        id={clickId}
      >
        {buttonLabel}
      </Button>
    </form>
  </div>
);

ActionForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  titleClassName: PropTypes.string,
  formClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  buttonClassName: PropTypes.string,
  theme: PropTypes.oneOf(themes),
  defaultValue: PropTypes.string,
  validationSchema: PropTypes.object,
  type: PropTypes.string,
  clickId: PropTypes.string,
  autoFocus: PropTypes.bool,
};

ActionForm.defaultProps = {
  buttonLabel: 'Submit',
  placeholder: '',
  theme: 'waybetter',
  defaultValue: '',
  type: 'text',
  autoFocus: false,
};

export default withFormik({
  displayName: 'ActionForm',
  mapPropsToValues: ({ defaultValue }) => ({ value: defaultValue }),
  validateOnChange: false,
  validateOnBlur: false,
  validationSchema: ({ validationSchema }) =>
    validationSchema
      ? validationSchema
      : object().shape({
          value: string().required(),
        }),
  handleSubmit: async (
    { value },
    { props: { onSubmit }, setSubmitting, resetForm }
  ) => {
    setSubmitting(true);
    await onSubmit(value);
    resetForm();
  },
})(ActionForm);
